export const checkoutUrl = 'https://masterjazz.impultienda.ar/checkout';
